var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Expose } from "class-transformer";
import { IsInt } from "class-validator";
import { safeAssign } from "./safe-assign";
export class VenueDTO {
    // TODO: add holidays
    // TODO: add stateName
    constructor(props) {
        safeAssign(this, props);
    }
}
__decorate([
    Expose(),
    __metadata("design:type", Number)
], VenueDTO.prototype, "id", void 0);
__decorate([
    Expose(),
    __metadata("design:type", Number)
], VenueDTO.prototype, "venueNumber", void 0);
__decorate([
    Expose(),
    __metadata("design:type", String)
], VenueDTO.prototype, "name", void 0);
__decorate([
    Expose(),
    __metadata("design:type", String)
], VenueDTO.prototype, "address", void 0);
__decorate([
    Expose(),
    __metadata("design:type", String)
], VenueDTO.prototype, "city", void 0);
__decorate([
    Expose(),
    __metadata("design:type", String)
], VenueDTO.prototype, "postalCode", void 0);
__decorate([
    Expose(),
    __metadata("design:type", String)
], VenueDTO.prototype, "state", void 0);
__decorate([
    Expose(),
    __metadata("design:type", String)
], VenueDTO.prototype, "phone", void 0);
__decorate([
    Expose(),
    __metadata("design:type", Number)
], VenueDTO.prototype, "order", void 0);
__decorate([
    Expose(),
    __metadata("design:type", Array)
], VenueDTO.prototype, "departmentIds", void 0);
export class VenueStructureDTO {
    // TODO: add holidays
    // TODO: add stateName
    constructor(props) {
        safeAssign(this, props);
    }
}
__decorate([
    Expose(),
    __metadata("design:type", Number)
], VenueStructureDTO.prototype, "id", void 0);
__decorate([
    Expose(),
    __metadata("design:type", Number)
], VenueStructureDTO.prototype, "venueNumber", void 0);
__decorate([
    Expose(),
    __metadata("design:type", String)
], VenueStructureDTO.prototype, "name", void 0);
__decorate([
    Expose(),
    __metadata("design:type", String)
], VenueStructureDTO.prototype, "address", void 0);
__decorate([
    Expose(),
    __metadata("design:type", String)
], VenueStructureDTO.prototype, "city", void 0);
__decorate([
    Expose(),
    __metadata("design:type", String)
], VenueStructureDTO.prototype, "postalCode", void 0);
__decorate([
    Expose(),
    __metadata("design:type", String)
], VenueStructureDTO.prototype, "state", void 0);
__decorate([
    Expose(),
    __metadata("design:type", String)
], VenueStructureDTO.prototype, "phone", void 0);
__decorate([
    Expose(),
    __metadata("design:type", Number)
], VenueStructureDTO.prototype, "order", void 0);
__decorate([
    Expose(),
    __metadata("design:type", Array)
], VenueStructureDTO.prototype, "departments", void 0);
export class TransferVenueDTO {
    constructor(props) {
        safeAssign(this, props);
    }
}
__decorate([
    Expose(),
    IsInt(),
    __metadata("design:type", Number)
], TransferVenueDTO.prototype, "venueId", void 0);
__decorate([
    Expose(),
    IsInt(),
    __metadata("design:type", Number)
], TransferVenueDTO.prototype, "targetCompanyId", void 0);
//# sourceMappingURL=venue.dto.js.map